export const infoData = {
  farmers: {
    title: "Our Farmers",
    subtitle: "The hands that nurture the soul of our spices.",
    content: `
      <h2>Direct Partnership</h2>
      <p>At Ragini Masale, we believe in a fair and transparent supply chain. We work directly with over 500 small-scale farmers across the spice-rich regions of India, from the turmeric fields of Meghalaya to the cardamom plantations of Kerala.</p>
      <h2>Sustainable Growth</h2>
      <p>We empower our farming partners by providing them with premium seeds, organic fertilizers, and training in sustainable farming practices. By eliminating middlemen, we ensure that the farmers receive the true value for their labor.</p>
    `
  },
  process: {
    title: "Our Process",
    subtitle: "Honoring ancient wisdom through modern precision.",
    content: `
      <h2>Stone-Grinding Mastery</h2>
      <p>While industrial processing uses high-speed rollers that generate heat and destroy volatile oils, our traditional stone-grinding process is slow and cold. This preserves the aromatic soul and nutritional integrity of every spice.</p>
      <h2>Sun-Dried Perfection</h2>
      <p>Every spice is naturally cured under the sun to lock in the vibrant colors and essential nutrients before they are brought to our studio for grinding.</p>
    `
  },
  faqs: {
    title: "Expertly Answered",
    subtitle: "Deep dives into the science and tradition of our masalas.",
    content: `
      <div class="faq-section">
        <h3>Purity & Sourcing</h3>
        <div class="faq-item">
          <h4>Are your spices organic?</h4>
          <p>We prioritize "Beyond Organic" standards. While many of our farms carry organic certifications, our focus is on zero-residue farming. Every batch of Ragini Masale undergoes 112 quality checks, including moisture content, volatile oil levels, and zero-adulteration tests for artificial colors like Metanil Yellow or Sudan Red.</p>
        </div>
        <div class="faq-item">
          <h4>Where is the turmeric sourced from?</h4>
          <p>Our Lakadong Turmeric comes exclusively from the Jaintia Hills of Meghalaya, known for the highest Curcumin content (up to 7-9%) in the world. Our Chillies are sourced from the Guntur region for heat and Kashmir for that signature deep red color without the burn.</p>
        </div>
        
        <h3>The Craft (Stone-Grinding)</h3>
        <div class="faq-item">
          <h4>What is the benefit of Stone-Grinding?</h4>
          <p>Industrial hammer mills operate at high speeds (3000+ RPM), generating heat up to 90°C. This heat evaporates the essential oils (the flavor). Our traditional stone grinders (Khal-Batta process) operate at low temperatures, ensuring that the aroma and health benefits of the spices remain intact until they reach your kitchen.</p>
        </div>
        
        <h3>Storage & Shelf Life</h3>
        <div class="faq-item">
          <h4>How should I store my masalas?</h4>
          <p>Spices are light and heat-sensitive. To maintain their "just-ground" aroma, store them in our moisture-resistant pouches or transfer them to airtight dark glass jars. Avoid keeping them near the stove where heat and steam can degrade their quality.</p>
        </div>
      </div>
    `
  },
  privacy: {
    title: "Privacy Commitment",
    subtitle: "Protecting your digital footprint as carefully as our recipes.",
    content: `
      <div class="legal-section">
        <h3>1. Data We Collect</h3>
        <p>We only collect data that enhances your experience. This includes basic contact info for newsletter delivery and anonymized analytics to see which recipes you love the most.</p>
        
        <h3>2. How We Use Information</h3>
        <ul>
          <li><strong>Personalization:</strong> Recommending spices based on your browsing history.</li>
          <li><strong>Communication:</strong> Sharing seasonal recipes and "Behind the Mill" stories.</li>
          <li><strong>Security:</strong> Protecting our community from fraudulent activities.</li>
        </ul>
        
        <h3>3. Zero Third-Party Sharing</h3>
        <p>Your data is as sacred as our family recipes. We never sell or share your personal information with third-party advertisers. All data is encrypted and stored on secure servers.</p>
      </div>
    `
  },
  terms: {
    title: "Ethical Engagement",
    subtitle: "The rules of our culinary community.",
    content: `
      <div class="legal-section">
        <h3>1. Intellectual Property</h3>
        <p>The "Ragini Masale" brand, our unique spice blend ratios, and the professional photography on this site are legally protected. You are welcome to share our recipes, but commercial use or reproduction of our content is prohibited without written consent.</p>
        
        <h3>2. Authentic Product Guarantee</h3>
        <p>We guarantee that every gram of spice you receive from Ragini Masale is 100% pure. If any product fails to meet the aromatic standards we promise, we will replace it immediately through our Quality Assurance program.</p>
        
        <h3>3. Community Guidelines</h3>
        <p>We encourage sharing and feedback on our "Spice Journal" blogs. However, we maintain a respectful community. Any harmful or offensive content in comments will be moderated to preserve the purity of our platform.</p>
      </div>
    `
  },
  sitemap: {
    title: "Digital Map",
    subtitle: "Navigate through our heritage and collections.",
    content: `
      <div class="sitemap-grid">
        <div class="sitemap-col">
          <h3>The Brand</h3>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/story">Heritage & Story</a></li>
            <li><a href="/farmers">Our Farmers</a></li>
            <li><a href="/process">The Process</a></li>
          </ul>
        </div>
        <div class="sitemap-col">
          <h3>The Pantry</h3>
          <ul>
            <li><a href="/products">All Collections</a></li>
            <li><a href="/products">Signature Blends</a></li>
            <li><a href="/products">Luxury Series</a></li>
            <li><a href="/products">Farm Fresh</a></li>
          </ul>
        </div>
        <div class="sitemap-col">
          <h3>The Journal</h3>
          <ul>
            <li><a href="/recipes">Recipes</a></li>
            <li><a href="/blogs">Culinary Insights</a></li>
            <li><a href="/contact">Contact & Inquiries</a></li>
          </ul>
        </div>
        <div class="sitemap-col">
          <h3>Legal & FAQ</h3>
          <ul>
            <li><a href="/faqs">Expert FAQs</a></li>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/terms">Terms of Service</a></li>
          </ul>
        </div>
      </div>
    `
  }
};
